"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentModerationResponseToJSON = exports.ContentModerationResponseFromJSONTyped = exports.ContentModerationResponseFromJSON = exports.instanceOfContentModerationResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ContentModerationResponse interface.
 */
function instanceOfContentModerationResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfContentModerationResponse = instanceOfContentModerationResponse;
function ContentModerationResponseFromJSON(json) {
    return ContentModerationResponseFromJSONTyped(json, false);
}
exports.ContentModerationResponseFromJSON = ContentModerationResponseFromJSON;
function ContentModerationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sensitiveTopics': !(0, runtime_1.exists)(json, 'sensitive_topics') ? undefined : json['sensitive_topics'],
        'guardrailTopics': !(0, runtime_1.exists)(json, 'guardrail_topics') ? undefined : json['guardrail_topics'],
    };
}
exports.ContentModerationResponseFromJSONTyped = ContentModerationResponseFromJSONTyped;
function ContentModerationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sensitive_topics': value.sensitiveTopics,
        'guardrail_topics': value.guardrailTopics,
    };
}
exports.ContentModerationResponseToJSON = ContentModerationResponseToJSON;
